<template>
  <div class="h-full flex flex-col justify-center space-y-2 px-4">
    <img
      alt="empty cart icon"
      class="h-20"
      src="@/assets/icons/emptycart.svg"
    />
    <p class="font-bold text-lg">Your cart is Empty</p>

    <div>
      <button
        @click="shop"
        class="shadow-lg border-white border font-bold text-lg p-1 px-4 rounded-full bg-bnb-mustard bg-opacity-70 text-white"
      >
        Go shopping
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    shop() {
      this.$store.commit("currentComponent", "Menu");
    },
  },
};
</script>
